import React from 'react';
import {
  Box, Grid, SvgIcon, Typography,
} from '@material-ui/core';
import { ReactComponent as FilledPersonIcon } from '../components/filledPersonIcon.svg';
import { ReactComponent as OutlinedPersonIcon } from '../components/outlinedPersonIcon.svg';

interface PredictionProps {
  prediction: number;
  title: string;
  className?: string;
}
function Prediction(props: PredictionProps): JSX.Element {
  const {
    prediction, title, className,
  } = props;
  return (
    <Grid item className={className}>
      <Grid container spacing={2} justify="center">
        <Grid item xs={12} style={{ maxWidth: '750px' }}>
          <Typography variant="body2">
            {title}
          </Typography>
        </Grid>
        <Grid item container spacing={2} style={{ maxWidth: '750px' }} alignItems="center">
          <Grid item container spacing={0} sm={6} xs={12} style={{ maxWidth: '260px' }}>
            {Array.from({ length: 100 }, (_, i) => {
              if (i <= prediction) {
                return (
                  <Grid item key={`icon-${i}`}>
                    <SvgIcon component={FilledPersonIcon} color="error" />
                  </Grid>
                );
              }
              return (
                <Grid item key={`icon-${i}`}>
                  <SvgIcon component={OutlinedPersonIcon} color="primary" />
                </Grid>
              );
            })}
          </Grid>
          <Grid item sm={6} xs={12}>
            <Typography style={{ fontSize: '1.1em', whiteSpace: 'pre-line' }} component="div">
              <Box fontWeight="bold" display="inline">{`${Math.floor(prediction)} out of 100`}</Box>
              {' '}
              patients have a Grade &ge; 2 complication,
              <Box fontWeight="bold" display="inline">{`\n${100 - Math.floor(prediction)} do not`}</Box>
              .
            </Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

Prediction.defaultProps = {
  className: '',
};

export default Prediction;
